module.exports = __webpack_public_path__ + "img/af.38106785.png";